import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActivationStep from "../components/Activation/ActivationStep";
import ChooseSubscription from "../components/Payment/ChooseSubscription";
import Login from "./Login";
import { StatsData } from "../types/Signup/SignUpStep";

export default function Activation() {
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [sundhedsfaglig, setSundhedsfaglig] = useState(false);
  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);

  const [statsData, setStatsData] = useState<StatsData>({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();
        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    async function confirmUser() {
      try {
        const response = await fetch(
          `https://test.doctio.dk/api/activate/${id}`
        );
        const jsonData = await response.json();
        console.log(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    async function getOptions() {
      try {
        const response = await fetch(
          `https://test.doctio.dk/api/activations/${id}/subscriptionoptions`
        );
        const jsonData = await response.json();
        console.log(jsonData);
        setSundhedsfaglig(!jsonData.pro);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    getOptions();
    fetchData();
    confirmUser();
  }, [id]);

  switch (currentStep) {
    case 1:
      return <ActivationStep nextStep={nextStep} statsData={statsData} />;
    case 2:
      return (
        <ChooseSubscription
          activationId={id || ""}
          prevStep={prevStep}
          isSundhedsperson={sundhedsfaglig}
        />
      );
    case 3:
      return <Login />;

    default:
      return <div>Der er sket en fejl!</div>;
  }
}
